/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listMonitoringIntegrationsParamsTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listMonitoringIntegrationsParamsCursorMax = 512;

export const listMonitoringIntegrationsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listMonitoringIntegrationsParamsLimitDefault = 50;
export const listMonitoringIntegrationsParamsLimitMax = 100;

export const listMonitoringIntegrationsParamsSearchMax = 100;

export const ListMonitoringIntegrationsParams = zod.object({
  teamId: zod.uuid().regex(listMonitoringIntegrationsParamsTeamIdRegExp).optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listMonitoringIntegrationsParamsCursorMax)
    .regex(listMonitoringIntegrationsParamsCursorRegExp)
    .optional(),
  limit: zod
    .int()
    .min(1)
    .max(listMonitoringIntegrationsParamsLimitMax)
    .default(listMonitoringIntegrationsParamsLimitDefault),
  search: zod.string().max(listMonitoringIntegrationsParamsSearchMax).optional(),
  includeRetired: zod.union([zod.boolean(), zod.enum(['true', 'false'])]).optional(),
});

export type ListMonitoringIntegrationsParams = zod.input<typeof ListMonitoringIntegrationsParams>;
export type ListMonitoringIntegrationsParamsOutput = zod.output<
  typeof ListMonitoringIntegrationsParams
>;
